module.exports = __webpack_public_path__ + "static/media/dashboard.2ab8a2fe.png";